var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payment__instrument payments_form" },
    [
      !_vm.processing
        ? _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.submit.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c("span", { staticClass: "piitem-text" }, [
                _c("h2", { staticClass: "piitem-text-headline" }, [
                  _vm._v(_vm._s(_vm.$t("Transaction.Sightline")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "piitem-text-desc" }, [
                  _vm._v(_vm._s(_vm.$t("Payments.Nuvei.PlayPlus.Wd.Desc")))
                ])
              ]),
              _vm._v(" "),
              _c("v-text-field", {
                staticClass: "input-amount",
                attrs: {
                  inputmode: "decimal",
                  label: _vm.$t("Transaction.Amount"),
                  required: "",
                  prefix: _vm.currencySymbol,
                  disabled: _vm.processing,
                  rules: [
                    _vm.formRules.amount.required,
                    _vm.formRules.amount.max2Decimals
                  ]
                },
                model: {
                  value: _vm.amount,
                  callback: function($$v) {
                    _vm.amount = $$v
                  },
                  expression: "amount"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "buttons" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: _vm.processing || !_vm.valid,
                        color: "success"
                      },
                      on: { click: _vm.submit }
                    },
                    [_vm._v(_vm._s(_vm.$t("Transaction.Withdraw")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "outlined",
                      attrs: { color: "gray" },
                      on: { click: _vm.goToHomepage }
                    },
                    [
                      _c(
                        "i",
                        {
                          staticClass: "icon material-icons",
                          attrs: { "aria-hidden": "true" }
                        },
                        [_vm._v("navigate_before")]
                      ),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("Transaction.GoBack")) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "payments__spinner" },
            [
              _c("v-progress-circular", {
                staticClass: "redirecting-circular-progress",
                attrs: { indeterminate: "" }
              }),
              _vm._v(
                "\n    " + _vm._s(_vm.$t("Transaction.PleaseWait")) + "\n  "
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b1ddc700", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1ddc700","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/Nuvei/NuveiWdPlayPlus.vue
// module id = null
// module chunks = 